























































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import moment from "moment";
import Airport from "@/store/entities/flight/airport";
import FlightSearchInput from "@/store/entities/flight/flightSearchInput";
import FlightAvailabilityRoute from "@/store/entities/flight/flightAvailabilityRoute";

@Component({})
export default class FlightSearch extends Vue {
  breadcrumbsItems: any[] = [
    { text: "Ana Sayfa", disabled: false },
    { text: "Uçuş", disabled: false },
    { text: "Uçuş Arama", disabled: true },
  ];
  searchInput: FlightSearchInput = new FlightSearchInput();
  airports: Airport[] = [];
  routes: FlightAvailabilityRoute[] = [];
  fromCode: string = null;
  toCode: string = null;
  loading: boolean = false;
  currencyId: string = "EUR";
  refId: number = 999;
  searched: boolean = false;
  resultCards: any[] = [];

  departureMenu: boolean = false;
  returnMenu: boolean = false;
  passengerMenu: boolean = false;
  departurePickerDate: string = null;
  returnPickerDate: string = null;

  passengerTypes: any[] = [
    { key: "adultCount", label: "Yetişkin", icon: "fas fa-user-friends", min: 1 },
    { key: "childCount", label: "Çocuk (2-12)", icon: "fas fa-child", min: 0 },
    { key: "infantCount", label: "Bebek (0-2)", icon: "fas fa-baby", min: 0 },
  ];

  airportLabel(code: string): string {
    if (!code) return "";
    const match = this.airports.find(
      (a) => a.nameWithCode && a.nameWithCode.toUpperCase().indexOf(code.toUpperCase()) !== -1
    );
    return match ? match.nameWithCode : code;
  }

  get originItems() {
    const codes = Array.from(new Set(this.routes.map((r) => r.origin)));
    return codes
      .map((code) => ({ code, label: this.airportLabel(code) }))
      .sort((a, b) => a.label.localeCompare(b.label, "tr"));
  }

  get destinationItems() {
    if (!this.fromCode) return [];
    const dests = this.routes.filter((r) => r.origin === this.fromCode);
    return dests
      .map((r) => ({
        code: r.destination,
        label: this.airportLabel(r.destination),
        minPrice: r.minPrice,
      }))
      .sort((a, b) => a.label.localeCompare(b.label, "tr"));
  }

  get outboundRoute(): FlightAvailabilityRoute {
    if (!this.fromCode || !this.toCode) return null;
    return (
      this.routes.find(
        (r) => r.origin === this.fromCode && r.destination === this.toCode
      ) || null
    );
  }

  get returnRoute(): FlightAvailabilityRoute {
    if (!this.fromCode || !this.toCode) return null;
    return (
      this.routes.find(
        (r) => r.origin === this.toCode && r.destination === this.fromCode
      ) || null
    );
  }

  get allowedDepartureSet(): Set<string> {
    return new Set(this.outboundRoute ? this.outboundRoute.Dates : []);
  }

  get allowedReturnSet(): Set<string> {
    return new Set(this.returnRoute ? this.returnRoute.Dates : []);
  }

  isDepartureAllowed(val: string) {
    return this.allowedDepartureSet.has(val);
  }

  isReturnAllowed(val: string) {
    if (!this.allowedReturnSet.has(val)) return false;
    if (this.searchInput.departureDate) {
      return moment(val).isSameOrAfter(moment(this.searchInput.departureDate));
    }
    return true;
  }

  departureEvents(val: string) {
    return this.allowedDepartureSet.has(val) ? "#4caf50" : false;
  }

  returnEvents(val: string) {
    return this.allowedReturnSet.has(val) ? "#4caf50" : false;
  }

  get getDepartureDate() {
    return this.searchInput.departureDate
      ? moment(this.searchInput.departureDate).format("DD-MM-YYYY")
      : "";
  }

  get getReturnDate() {
    return this.searchInput.returnDate
      ? moment(this.searchInput.returnDate).format("DD-MM-YYYY")
      : "";
  }

  get hasResults() {
    return this.resultCards.length > 0;
  }

  get passengerSummary() {
    const a = Number(this.searchInput.adultCount);
    const c = Number(this.searchInput.childCount);
    const i = Number(this.searchInput.infantCount);
    let parts = [`${a} Yetişkin`];
    if (c > 0) parts.push(`${c} Çocuk`);
    if (i > 0) parts.push(`${i} Bebek`);
    return parts.join(", ");
  }

  increment(p: any) {
    this.searchInput[p.key] = Number(this.searchInput[p.key]) + 1;
  }

  decrement(p: any) {
    if (this.searchInput[p.key] > p.min) {
      this.searchInput[p.key] = Number(this.searchInput[p.key]) - 1;
    }
  }

  onFromChange() {
    this.toCode = null;
    this.resetDates();
  }

  onToChange() {
    this.resetDates();
    if (this.outboundRoute && this.outboundRoute.Dates.length) {
      const first = this.outboundRoute.Dates.slice().sort()[0];
      this.departurePickerDate = moment(first).format("YYYY-MM");
    }
  }

  resetDates() {
    this.searchInput.departureDate = null;
    this.searchInput.returnDate = null;
  }

  swapAirports() {
    const temp = this.fromCode;
    this.fromCode = this.toCode;
    this.toCode = temp;
    this.resetDates();
    this.onToChange();
  }

  @Watch("searchInput.tripType")
  onTripTypeChange() {
    if (this.searchInput.tripType !== "roundtrip") {
      this.searchInput.returnDate = null;
    }
  }

  @Watch("searchInput.departureDate")
  onDepartureChange() {
    if (
      this.searchInput.returnDate &&
      moment(this.searchInput.returnDate).isBefore(
        moment(this.searchInput.departureDate)
      )
    ) {
      this.searchInput.returnDate = null;
    }
    if (this.returnRoute && this.returnRoute.Dates.length) {
      const firstReturn = this.returnRoute.Dates.slice()
        .sort()
        .find((d) => moment(d).isSameOrAfter(moment(this.searchInput.departureDate)));
      if (firstReturn) {
        this.returnPickerDate = moment(firstReturn).format("YYYY-MM");
      }
    }
  }

  async created() {
    await Promise.all([this.getAirports(), this.getAvailability()]);
  }

  async getAirports() {
    await this.$store.dispatch({ type: "airport/getAirports", data: "{}" });
    this.airports = this.$store.state.airport.list;
  }

  async getAvailability() {
    this.loading = true;
    try {
      await this.$store.dispatch({
        type: "flight/getFlightAvailabilityPanel",
        data: {},
      });
      this.routes = this.$store.state.flight.availabilityRoutes || [];
    } finally {
      this.loading = false;
    }
  }

  async search() {
    if (!this.fromCode || !this.toCode) {
      Vue.$toast.error("Lütfen kalkış ve varış noktasını seçiniz!");
      return;
    }
    if (!this.outboundRoute) {
      Vue.$toast.error("Seçilen rota için uçuş bulunamadı!");
      return;
    }
    if (!this.searchInput.departureDate) {
      Vue.$toast.error("Lütfen gidiş tarihini seçiniz!");
      return;
    }
    if (this.searchInput.tripType === "roundtrip" && !this.searchInput.returnDate) {
      Vue.$toast.error("Lütfen dönüş tarihini seçiniz!");
      return;
    }

    const payload: any = {
      origin: this.fromCode,
      destination: this.toCode,
      departureDate: this.searchInput.departureDate,
      adultCount: Number(this.searchInput.adultCount),
      childCount: Number(this.searchInput.childCount),
      infantCount: Number(this.searchInput.infantCount),
      currencyId: this.currencyId,
      refId: this.refId,
    };

    if (this.searchInput.tripType === "roundtrip") {
      payload.arrivalDate = this.searchInput.returnDate;
    }

    this.loading = true;
    this.searched = false;
    try {
      const res = await this.$store.dispatch({
        type: "flight/searchFlight",
        data: payload,
      });
      this.buildResults(res && res.data && res.data.result ? res.data.result.flights : {});
      this.searched = true;
    } finally {
      this.loading = false;
    }
  }

  buildResults(flightsObj: any) {
    const obj = flightsObj || {};
    const keys = Object.keys(obj).sort((a, b) => Number(a) - Number(b));
    let all: any[] = [];
    keys.forEach((k) => (all = all.concat(obj[k] || [])));

    if (this.searchInput.tripType !== "roundtrip") {
      // Tek yön: her uçuş ayrı kart
      this.resultCards = all.map((f) => ({
        legs: [f],
        totalPrice: Number(f.price) || 0,
        currencyId: f.currencyId,
      }));
      return;
    }

    // Gidiş - Dönüş: rota yönüne göre ayır, indekse göre eşleştir
    const outRoute = `${this.fromCode}-${this.toCode}`;
    const retRoute = `${this.toCode}-${this.fromCode}`;
    let outbound = all.filter((f) => f.route === outRoute);
    let inbound = all.filter((f) => f.route === retRoute);

    // Rota bilgisi eşleşmezse ardışık ikili gruplama ile devam et
    if (!outbound.length || !inbound.length) {
      outbound = all.filter((_, i) => i % 2 === 0);
      inbound = all.filter((_, i) => i % 2 === 1);
    }

    const count = Math.max(outbound.length, inbound.length);
    const cards: any[] = [];
    for (let i = 0; i < count; i++) {
      const o = outbound[i];
      const r = inbound[i];
      const legs = [o, r].filter(Boolean);
      if (!legs.length) continue;
      const total =
        (o ? Number(o.price) || 0 : 0) + (r ? Number(r.price) || 0 : 0);
      cards.push({
        legs,
        totalPrice: total,
        currencyId: (o || r).currencyId,
      });
    }
    this.resultCards = cards;
  }

  formatHour(val: string) {
    return val ? moment(val).format("HH:mm") : "";
  }

  formatDuration(val: string) {
    if (!val) return "";
    const parts = String(val).split(/[.:]/);
    const h = parseInt(parts[0], 10) || 0;
    const m = parts.length > 1 ? parseInt(parts[1], 10) || 0 : 0;
    return `${h}h ${String(m).padStart(2, "0")}m`;
  }

  formatDay(val: string) {
    return val ? moment(val).format("DD MMM YYYY, dddd") : "";
  }

  selectFlight(flight: any) {
    this.$emit("flight-selected", flight);
  }
}
